import React from 'react';
import styled from '@emotion/styled';

const ImageEmbed = styled.img({
  margin: `0px auto`,
  maxWidth: `100%`
});

const StyledVideoContainer = styled.div`
  .video-root {
    margin: 0px auto;
    max-width: 755px;

    .video-wrapper {
      max-width: 1024px;
      position: relative;
      padding-bottom: 56.25%;
      height: 0;
      overflow: hidden;

      iframe {
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
`;

const VideoEmbed = ({ uri, externalID, title }) => {
  const videoEmbedURI = uri
    ? uri.replace('/watch?v=', '/embed/')
    : `https://www.youtube.com/embed/${externalID}`;

  return (
    <>
      <StyledVideoContainer>
        {title && <h2 style={{ width: `100%`, textAlign: `center`, padding: `20px` }}>{title}</h2>}
        <div className="video-root">
          <div className="video-wrapper">
            <iframe title={title} src={videoEmbedURI} allowFullScreen />
          </div>
        </div>
      </StyledVideoContainer>
    </>
  );
};

export { VideoEmbed, ImageEmbed };
